export const getInitialState = (): any => ({
  modelSummaryData: {},
  modelSummaryStatus: 0
});
